import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { v4 as uuid } from "uuid";
import cx from 'classnames'

export default function Tooltip({ className, place = 'top', iconClassName = "-translate-y-1 text-gray-700", content, Icon = QuestionMarkCircleIcon, children = null}) {
    const tooltipId = uuid();

    return (
        <>
            <a
                data-tooltip-id={tooltipId}
                data-tooltip-content={content}
                data-tooltip-place={place}
                className={className}
            >
                {Icon && <Icon className={cx("h-5 w-5", iconClassName)} />}
                {children}
            </a>
            <ReactTooltip id={tooltipId} />
        </>
    );
}
